import { render, staticRenderFns } from "./Redbag.vue?vue&type=template&id=0f9aed3b&"
import script from "./Redbag.vue?vue&type=script&lang=js&"
export * from "./Redbag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports